<!-- vertical layout -->
<app-vertical ></app-vertical>

 